import { alpha, styled } from '@mui/material/styles';
import { Tooltip as MuiTooltip } from '@mui/material';
import {
  operationalElevation,
  operationalFontSizes,
  operationalRadii,
  operationalSpacing
} from '../../../design-system/tokens';

/**
 * StyledTooltip - Estilos do átomo Tooltip
 *
 * CLASSIFICAÇÃO: ÁTOMO
 *
 * Estilos centralizados para o componente Tooltip base,
 * utilizando Design Tokens para consistência visual.
 *
 * @see https://bradfrost.com/blog/post/atomic-web-design/
 */

export const StyledTooltip = styled(({ className, ...props }) => (
  <MuiTooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  // Estilos base
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: operationalFontSizes.xs,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: operationalRadii.control,
    padding: theme.spacing(operationalSpacing.md),
    transition: theme.transitions.create(['opacity', 'transform'], {
      duration: theme.transitions.duration.shorter,
    }),
  },

  // Variante legada: sem blur/transparência na linguagem visual atual
  '&.glassmorphism .MuiTooltip-tooltip': {
    background: theme.palette.background.paper,
    backdropFilter: 'none',
    WebkitBackdropFilter: 'none',
    boxShadow: 'none',
  },

  // Variante outline
  '&.outline .MuiTooltip-tooltip': {
    border: `1px solid ${theme.palette.divider}`,
    background: 'transparent',
  },

  // Variante filled
  '&.filled .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },

  // Variante contrast - superficie clara para destacar sobre cards escuros
  '&.contrast .MuiTooltip-tooltip': {
    backgroundColor: alpha(theme.palette.common.white, 0.98),
    color: alpha(theme.palette.common.black, 0.88),
    border: `1px solid ${alpha(theme.palette.common.white, 0.72)}`,
    boxShadow: operationalElevation.modal,
  },

  // Variante MIA - painel técnico escuro para insights e métricas de IA
  '&.mia-control .MuiTooltip-tooltip': {
    background: `linear-gradient(145deg, ${alpha('#121920', 0.98)} 0%, ${alpha('#1d2630', 0.98)} 100%)`,
    color: alpha('#edf3f7', 0.9),
    border: `1px solid ${alpha('#95a3ad', 0.12)}`,
    borderLeft: `3px solid ${alpha('#6fa84f', 0.82)}`,
    boxShadow: '0 28px 72px rgba(3, 7, 12, 0.58)',
    borderRadius: operationalRadii.surface,
  },

  // Estilos da seta
  '& .MuiTooltip-arrow': {
    color: theme.palette.background.paper,
    '&::before': {
      border: `1px solid ${theme.palette.divider}`,
    },
  },

  // Variantes da seta
  '&.glassmorphism .MuiTooltip-arrow': {
    color: theme.palette.background.paper,
  },
  '&.outline .MuiTooltip-arrow': {
    color: 'transparent',
  },
  '&.filled .MuiTooltip-arrow': {
    color: theme.palette.primary.main,
  },
  '&.contrast .MuiTooltip-arrow': {
    color: alpha(theme.palette.common.white, 0.98),
    '&::before': {
      border: `1px solid ${alpha(theme.palette.common.white, 0.72)}`,
    },
  },
  '&.mia-control .MuiTooltip-arrow': {
    color: alpha('#1d2630', 0.98),
    '&::before': {
      border: `1px solid ${alpha('#95a3ad', 0.12)}`,
    },
  },
}));
